export const ENDPOINTS = {
  get_exhibition: "teaming/teams/exhibition/",
};